import $ from 'jquery';

const collapsible = () => {
    $('.js-collapsible').each(function() {
        const $element = $(this);
        const $trigger = $('.js-collapsible-trigger', $element);
        const $content = $('.js-collapsible-content', $element);

        $trigger.on('click', () => {
            $content.slideToggle('slow', () => {
                $trigger.children().toggleClass('is-open');
            });
        });
    });
};

$(() => {
    collapsible();
});
